// Castintech dashboard — Deploy History view (Faz 30).
// Endpoint: GET /castintech-api/deploy/recent (Faz 25 PR-D-1 — read-only).
// Tablo: zaman, triggered_by, reason, host, status (OK/FORCE/ABORT-*).
// Hicbir admin-bearer islem yok; sadece read-only display.

import { apiFetch } from '../api.js';
import { escHtml, escAttr, ago, $ } from '../utils.js';

interface DeployRow {
  id: number;
  ts: string;
  triggered_by: string;
  reason: string;
  host: string;
  status: string;
  raw?: string;
}

let cache: DeployRow[] = [];

export async function loadDeployHistory(): Promise<void> {
  try {
    const r = await apiFetch('/castintech-api/deploy/recent?limit=50');
    if (!r.ok) throw new Error('deploy/recent HTTP ' + r.status);
    const data = (await r.json()) as { rows?: DeployRow[]; deploys?: DeployRow[] };
    cache = Array.isArray(data.rows) ? data.rows : (Array.isArray(data.deploys) ? data.deploys : []);
    renderDeployHistory();
  } catch (e) {
    console.warn('loadDeployHistory failed:', (e as Error).message);
    const root = $('deploy-history-content');
    if (root) {
      root.innerHTML = `<div class="audit-empty">Deploy gecmisi yuklenemedi: ${escHtml((e as Error).message)}</div>`;
    }
  }
}

function statusColor(status: string): string {
  const s = String(status || '').toLowerCase();
  if (s.startsWith('ok')) return 'ok';
  if (s.startsWith('force')) return 'warn';
  if (s.startsWith('abort')) return 'err';
  return 'muted';
}

export function renderDeployHistory(): void {
  const root = $('deploy-history-content');
  const sub = $('deploy-history-sub');
  if (!root) return;
  if (sub) sub.textContent = `${cache.length} kayit · son 50 deploy`;
  if (!cache.length) {
    root.innerHTML = '<div class="audit-empty">Deploy kaydi yok.</div>';
    return;
  }
  const rows = cache.map(r => {
    const cls = statusColor(r.status);
    return `
      <div class="audit-row">
        <span class="audit-badge ${cls}">${escHtml(r.status || '?')}</span>
        <div class="audit-body">
          <div class="audit-msg"><b>${escHtml(r.triggered_by || '?')}</b> · ${escHtml(r.reason || '')}</div>
          <div class="audit-meta-line">host=${escHtml(r.host || '?')}</div>
        </div>
        <span class="audit-time" title="${escAttr(r.ts || '')}">${ago(r.ts || '')} once</span>
      </div>`;
  }).join('');
  root.innerHTML = rows;
}
